export const PRIVACY_SETTINGS_INTERCOM_LINK =
  'https://helpcenter.eversportsmanager.com/de/einstellungen-zur-privatsphäre-deines-eversports-profils-eversports-help-center-deutsch'
